module.exports = __webpack_public_path__ + "img/avatar1.3666f216.png";